import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const SOCKET_URL = BACKEND_URL;
export const SOCKET_PATH = "/api/socket.io";

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("session_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Stable per-browser/PC identity so each machine keeps its own Session ID.
export function getDeviceKey() {
  let key = localStorage.getItem("nexus_device_key");
  if (!key) {
    key = (crypto.randomUUID && crypto.randomUUID()) ||
      `dk_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("nexus_device_key", key);
  }
  return key;
}

export function detectDeviceName() {
  const ua = navigator.userAgent || "";
  let os = "Device";
  if (/Windows/i.test(ua)) os = "Windows PC";
  else if (/Macintosh|Mac OS/i.test(ua)) os = "Mac";
  else if (/Android/i.test(ua)) os = "Android";
  else if (/iPhone|iPad/i.test(ua)) os = "iOS";
  else if (/Linux/i.test(ua)) os = "Linux PC";
  let browser = "";
  if (/Edg\//i.test(ua)) browser = "Edge";
  else if (/Chrome\//i.test(ua)) browser = "Chrome";
  else if (/Firefox\//i.test(ua)) browser = "Firefox";
  else if (/Safari\//i.test(ua)) browser = "Safari";
  return browser ? `${os} · ${browser}` : os;
}

export default api;
